// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"c3906c0b","361":"47362fa9","767":"600cb282"}[chunkId] + ".chunk.js";
};